import { useAppContext } from '@pagegrowler_nextjs';
import { PagegrowlerBackendInstance } from '@pagegrowler_nextjs_ssr';
import NotFoundTemplate from './404.js';
import InternalErrorTemplate from './500.js';
import { pagegrowlerConfigBackend } from '../pagegrowler.config';
import { getSuscriptionPrice, getBucketsHeaders, getDataByFetch , getBucketByIdFromOle, getEnabledCrossContent, getServiceData, getEnabledElleMagazines, getBucketElleMagazines, getLastCover, getEnabledMostRead, addPlacementIdToContent, getEnabledWidget, getMaMWorldCupData } from 'helpers';
import { rules } from '../rules/index.js'
import axios from "axios";

export async function getServerSideProps(context) {
    const pagegrowlerFrontendApiUrl = process.env.PAGEGROWLER_FRONTEND_API ?? process.env.NEXT_PUBLIC_PAGEGROWLER_FRONTEND_API;

    let pagegrowlerBackendInstance = PagegrowlerBackendInstance();
    pagegrowlerBackendInstance.setPagegrowlerFrontendApiUrl(pagegrowlerFrontendApiUrl);
    pagegrowlerBackendInstance.setEndpointConfig(rules);
    pagegrowlerBackendInstance.setExternalConfig(pagegrowlerConfigBackend);

    const result = await pagegrowlerBackendInstance.handleGetServerSideProps(context, false);
    const suscriptionPrice = await getSuscriptionPrice();

    // Configuración del proxy basada en las variables de entorno
    const useProxy = process.env.USE_PROXY === 'true';
    const proxy = useProxy
    ? {
        protocol: 'http',
        host: process.env.PROXY_HOST,
        port: parseInt(process.env.PROXY_PORT, 10)
    }
    : false;
    const config = useProxy ? { proxy } : {};

    if (result?.props?.matchConfig?.status === 301 && result?.props?.matchConfig?.redirectTo) {
        if (result?.props?.matchConfig?.redirectTo.type === 'tag') {
            const { res } = context;
            res.writeHead(301, { location: `/tema/${result.props.matchConfig.redirectTo.value}.html` });
            res.end();
            return {
                props: {},
            };
        }

        if (result?.props?.matchConfig?.redirectTo.type === 'url') {
            const { res } = context;
            res.writeHead(301, { location: result.props.matchConfig.redirectTo.value });
            res.end();
            return {
                props: {},
            };
        }
    }
    if (result.notFound === true) {
        const { res } = context;
        res.statusCode = 404;
        if(result?.props?.menu) {
            result.props.menu.suscriptionPrice = suscriptionPrice;
        }
        let propsNotFound = result.props;
        result.props.properties = {};
        result.props.properties.bucketsHeader = {                
            liveblogs:  result.props.menu?.liveblogs?.item?.items ?? [],
        };
        propsNotFound.uri = context.resolvedUrl;
        return { props: { errorCode: 404, data: propsNotFound } };
    }

    if (!result.notFound) {
        if (result.props.matchConfig.type === 'redirect') { //redireccion dura
            const { res } = context;
            res.writeHead(301, { location: result.props.matchConfig.config.url });
            res.end();
            return {
                props: {},
            };
        }
    }

    if (result.props && result.props.matchConfig) { 
        let dateNow =  new Date()

        const typesNews = ['Nota', 'Gallery', 'Video', 'RecipeNews', 'Elections']; 
        if(typesNews.includes(result.props.matchConfig.template) && !!process.env.DEPLOY_DATE && result.props.matchConfig?.content?.lastModified){
            const date_deploy = new Date(process.env.DEPLOY_DATE);
            const date_modified = new Date(result.props.matchConfig.content.lastModified);           
            const diff = date_deploy.getTime() - date_modified.getTime();
            if(diff > 0){
               context.res.setHeader('Last-Modified', date_deploy.toUTCString());                
            } else {
                context.res.setHeader('Last-Modified', date_modified.toUTCString());
            }
        } else {
            context.res.setHeader('Last-Modified', dateNow.toUTCString());
        } 
        
        if (!result.props.matchConfig.properties) {
            result.props.matchConfig.properties = {};
        }

        if('RecipeNews'.includes(result.props.matchConfig.template)) {
        
            try {

                const noteId = context.req.url.replace(".html", "").split("_7_")[1];

                const { data } = await axios.get(`${process.env.NEXT_PUBLIC_RAZOR_MEDIA}/review-api/subjectsummary?externalSubjectIdList=_7_${noteId}`, config);

                const dataReview = data?.[0];

                result.props.matchConfig.properties.schemaReview = dataReview;
                
            } catch (error) {
                result.props.matchConfig.properties.schemaReview = null;
                // console.log('Error al obtener los datos:', error);
            }
        } 
        
        if(result.props.matchConfig.template === 'TemplateBuilder'){
            const { opinion, ultimomento } = await getBucketsHeaders(true);            
            result.props.matchConfig.properties.bucketsHeader = {
                opinion: (opinion !== false)? opinion?.content : [],
                liveblogs: result.props.matchConfig?.menu?.liveblogs?.item?.items ?? [],
                ultimomento: (ultimomento !== false)? ultimomento?.content : [],
            }

            //Get jokes
            const authBasic = "Basic " + Buffer.from('clarin:d2AYHZPFmKRa').toString('base64');
            const jokes =  await getDataByFetch(process.env.API_HANDLER_BACKEND_URL + '/api/humor/maitena', true, 'gzip', authBasic);        
            result.props.matchConfig.properties.jokes = 
                (jokes !== false && !jokes?.error)
                    ? { content: jokes?.jokes ?? [] }
                    : { error: true };
            
            const enableCrossContent = getEnabledCrossContent(result.props.matchConfig.content?.boxes)
            if(enableCrossContent) {
                const dataCrossContent = await getBucketByIdFromOle('ole-en-clarin');
                result.props.matchConfig.properties.crossContent = dataCrossContent;
            }
            const enableElleMagazines = getEnabledElleMagazines(result.props.matchConfig.content?.boxes)
            if(enableElleMagazines) {
                const dataElleMagazines = await getBucketElleMagazines();
                result.props.matchConfig.properties.elleMagazines = dataElleMagazines;
            } 
            const enableMostRead = getEnabledMostRead(result.props.matchConfig.content?.boxes)
            if(enableMostRead) {
                //const url_mostReadNews= `${process.env.LILAX_FRONTEND_API}viewed/?type=lilanews&limit=6&provider=bi`;
                const url_mostReadNews= `${pagegrowlerFrontendApiUrl}lilanews?type=listType&viewed=true&provider=bi&limit=6`; 
                const mostReadNews =  await getDataByFetch(`${url_mostReadNews}`, true);
                
                result.props.matchConfig.properties.mostReadNewsWidget = (mostReadNews !== false && mostReadNews.content)
                    ? mostReadNews.content
                    : [];
            }

        } else {
            const { urgent } = await getBucketsHeaders();                        
            result.props.matchConfig.properties.bucketsHeader = {                
                liveblogs: result.props.matchConfig?.menu?.liveblogs?.item?.items ?? [],
                urgent: urgent?.menu?.items ?? [],
            }            
        }        

        if (result.props.matchConfig.template === 'Service') {
            const service = await getServiceData(result.props.matchConfig.query, result.props.matchConfig.menu);
            if (service?.data?.redirect) {
                const { res } = context;
                res.writeHead(301, { location: service.data.redirect });
                res.end();
                return { props: {} };
            }
            if(service?.data?.code == 404){
                const { res } = context;
                res.statusCode = 404;
                if(result?.props?.menu) {
                    result.props.menu.suscriptionPrice = suscriptionPrice;
                }
                let propsNotFound = result.props;
                result.props.properties = {};
                result.props.properties.bucketsHeader = {                
                    liveblogs:  result.props.menu?.liveblogs?.item?.items ?? [],
                };
                propsNotFound.uri = context.resolvedUrl;
                return { props: { errorCode: 404, data: propsNotFound } };
            }
            result.props.matchConfig.properties.service = service.parseDataToFront();
            const urlArray = context.req.url.split("/")
            const purgueObj = {
                "economia" : "EXCHANGE",
                "horoscopo" : "HOROSCOPE",
                "juegos" : "GAMES",
                "claringrilla" : "CLARINGRILLA",
                "clima" : "WEATHER",
                "feriados" : "HOLIDAYS",
                "loterias-y-quinielas" : "LOTTERY",
                "humor" : "HUMOR"
            }
            if(urlArray?.[1] && purgueObj?.[urlArray[1].replace("?app=true","")]) {
                context?.res?.setHeader('Cache-Tag', purgueObj[urlArray[1].replace("?app=true","")])
                context?.res?.setHeader('X-Invalidated-By', purgueObj[urlArray[1].replace("?app=true","")])
            }
        }

        
        if (result.props.matchConfig.template === 'Elections') {
            const service = await getServiceData(result.props.matchConfig.query, result.props.matchConfig.menu);
            if(service?.data.code == 404){
                const { res } = context;
                res.statusCode = 404;
                if(result?.props?.menu) {
                    result.props.menu.suscriptionPrice = suscriptionPrice;
                }
                let propsNotFound = result.props;
                result.props.properties = {};
                result.props.properties.bucketsHeader = {                
                    liveblogs:  result.props.menu?.liveblogs?.item?.items ?? [],
                };
                propsNotFound.uri = context.resolvedUrl;
                return { props: { errorCode: 404, data: propsNotFound } };
            }
            result.props.matchConfig.properties.service = service.parseDataToFront();

            const urlArray = context.req.url.split("/")
            const purgueObj = {}
            if(urlArray?.[1] && purgueObj?.[urlArray[1].replace("?app=true","")]) {
                context?.res?.setHeader('Cache-Tag', purgueObj[urlArray[1].replace("?app=true","")])
                context?.res?.setHeader('X-Invalidated-By', purgueObj[urlArray[1].replace("?app=true","")])
            }
        }
        
        if(result.props.matchConfig?.menu) {
            result.props.matchConfig.menu.suscriptionPrice = suscriptionPrice;
        }

        if (result.props.matchConfig?.properties) {            
            const lastCover = await getLastCover(); 
            result.props.matchConfig.properties.lastCover = lastCover?.data ?? [];
        }
        if(result.props?.matchConfig?.content) {
            result.props.matchConfig.content = addPlacementIdToContent(result.props.matchConfig.content, result.props.matchConfig.template);
        }

        // const enableMamWorldCupWidget = getEnabledWidget(result.props.matchConfig.content.boxes, "MAMWorldCup");
        // if(enableMamWorldCupWidget) {
        //     const idOptaMundial = '70excpe1synn9kadnbppahdn7';
        //     const data = await getMaMWorldCupData(idOptaMundial);
            
        //     result.props.matchConfig.properties.MAMWorldCupContent =  data?.data?.match
        //         ? data.data.match
        //         : [];
        // }
    }
    return result;
}

const Match = (props) => {
    let Pagegrowler = useAppContext().pagegrowler;
    const {
        matchConfig,
        errorCode,
        data
    } = props;

    if(errorCode) {
        if(errorCode === 404) {
            return <NotFoundTemplate statusCode={errorCode} widgets={data.widgets} menu={data.menu} properties={data.properties}/>
        } else {
            return <InternalErrorTemplate statusCode={errorCode}/>
        }
    }


    return Pagegrowler.handleMatch(matchConfig);
}

export default Match;